import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useState,
} from "react";

import {
    IconButton,
    InputAdornment,
    TextField,
} from "@mui/material";

import ClearIcon from "@mui/icons-material/Clear";

const ColumnFilterTextField = forwardRef(
    (
        {
            columnId,
            initialValue = "",
            placeholder = "Type and Search",
            applyColumnFilter,
            width = "100%",
            isApplied = false,
            applyFilters
        },
        ref
    ) => {
        const [value, setValue] = useState(initialValue);

        useEffect(() => {
            setValue(initialValue ?? "");
        }, [initialValue]);

        useImperativeHandle(ref, () => ({
            getValue: () => value,

            clear: (triggerApply = false) => {
                setValue("");

                if (triggerApply) {
                    applyColumnFilter(columnId, "");
                }
            }
        }));

        const handleChange = (e) => {
            const newValue = e.target.value;

            setValue(newValue);

            // User removed last character
            if (
                newValue === "" &&
                value !== "" &&
                isApplied
            ) {
                applyColumnFilter(columnId, "");
            }
        };

        const handleKeyDown = (e) => {
            if (e.key === "Enter") {
                applyFilters();
            }
        };

        const handleClear = () => {
            setValue("");

            if (isApplied) {
                applyColumnFilter(columnId, "");
            }
        };

        return (
            <TextField
                fullWidth
                variant="standard"
                size="small"
                value={value}
                placeholder={placeholder}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                sx={{
                    width,
                    "& .MuiInputBase-input": {
                        borderBottom: "2px solid white",
                    },
                    "& .MuiInputBase-root::after": {
                        transform: "none",
                        borderBottom: "2px solid white",
                    },
                }}
                InputProps={{
                    endAdornment:
                        value && (
                            <InputAdornment position="end">
                                <IconButton
                                    size="small"
                                    onClick={handleClear}
                                >
                                    <ClearIcon fontSize="small" />
                                </IconButton>
                            </InputAdornment>
                        ),
                }}
            />
        );
    }
);

export default React.memo(ColumnFilterTextField);